import _ from 'lodash';
import moment from 'moment';
import apiFetch from 'utils/apiFetch';
import history from 'store/history';
import { PRIORITIES } from 'constants/serendipity';
import {
  NARRATIVE, ELEMENT, THINK_SEED, THINK_TANK, THEME_TABLE, SPEED_DATING_MEETING,
  FEEDBACK_USERS, FEEDBACK_TABLES,
} from 'constants/types';
import * as ACTION_TYPE from './types';

export const getOnGoingActivity = () => (dispatch, getState) => {
  const {
    serendipity: { preferences: serendipityPreferences, history: serendipityHistory },
    narratives: { list: narratives },
    speedDating: { meetings: speedDatingMeetings },
  } = getState();

  // Los puntos cuantos menos tenga mas preferencia tiene

  const serendipityItems = [];

  // Narratives
  let hasSomeNarrativeCompleted = false;
  _.forEach(narratives, (narrative) => {
    if (narrative.type.id === 21227761) {
      let points = 0;
      const isDisabled = _.find(serendipityPreferences, item => item.element_type === NARRATIVE && item.element_id === narrative.id && !item.enabled);
      const enabled = narrative.progress < 100 && !isDisabled;

      
      points += narrative.section.section_position * 100;

      
      points += narrative.position;
      if (narrative.progress > 0) {
        points -= 5000;
      }
      if (narrative.progress >= 100) {
        points += 10000;
        hasSomeNarrativeCompleted = true;
      }

      if (isDisabled) {
        points += 50000;
      }

      const serendipityInfo = {
        type: NARRATIVE,
        order: points,
        enabled,
      };

      const serendipityItem = { ...narrative, serendipityInfo };
      serendipityItems.push(serendipityItem);
    }
  });

  // Si tiene ya alguna narrativa completada
  // O tiene ya algo en el histórico que no sea el feedback users
  // Y las dos últimas cosas que le ha recomendado no es el feedback users
  const historyLength = serendipityHistory.length;
  let noRecentFeedbackHistory = true;
  if (historyLength > 0 && serendipityHistory[historyLength - 1].serendipityInfo.type === FEEDBACK_USERS) {
    noRecentFeedbackHistory = false;
  }
  if (historyLength > 1 && serendipityHistory[historyLength - 2].serendipityInfo.type === FEEDBACK_USERS) {
    noRecentFeedbackHistory = false;
  }
  if ((hasSomeNarrativeCompleted || historyLength) && noRecentFeedbackHistory) {
    const serendipityItemFeedbackUsers = {
      serendipityInfo: {
        type: FEEDBACK_USERS,
        order: -50000,
        enabled: true,
      },
    };
    serendipityItems.push(serendipityItemFeedbackUsers);
  }

  // Si las dos últimas cosas que le ha recomendado no es el feedback tables
  let noRecentFeedbackHistoryTables = true;
  if (historyLength > 0 && serendipityHistory[historyLength - 1].serendipityInfo.type === FEEDBACK_TABLES) {
    noRecentFeedbackHistoryTables = false;
  }
  if (historyLength > 1 && serendipityHistory[historyLength - 2].serendipityInfo.type === FEEDBACK_TABLES) {
    noRecentFeedbackHistoryTables = false;
  }
  if (noRecentFeedbackHistoryTables) {
    const serendipityItemFeedbackUsers = {
      serendipityInfo: {
        type: FEEDBACK_TABLES,
        order: -60000,
        enabled: true,
      },
    };
    serendipityItems.push(serendipityItemFeedbackUsers);
  }

  // Speed dating calls
  _.forEach(speedDatingMeetings, (element) => {
    let enabled = !_.find(serendipityPreferences, item => item.element_type === SPEED_DATING_MEETING && item.element_id === element.id && !item.enabled);

    const order = -70000;
    if (moment().unix() <= (element.start_date + 60) || moment().unix() > (element.end_date)) {
      enabled = false;
    }

    if (enabled) {
      const serendipityInfo = {
        type: SPEED_DATING_MEETING,
        order,
        enabled,
      };

      const serendipityItem = { ...element, serendipityInfo };
      serendipityItems.push(serendipityItem);
    }
  });

  return _.sortBy(serendipityItems, ['serendipityInfo.order']);
};

export const enableItemFromSerendipity = (elementType, elementId) => (dispatch) => {
  dispatch({
    type: ACTION_TYPE.ENABLE_ITEM_INIT,
    payload: { elementType, elementId },
  });

  const params = { element_type: elementType, element_id: elementId };
  return apiFetch('POST', { endPoint: 'serendipity/items/enable' }, params)
    .then(() => {
      dispatch({
        type: ACTION_TYPE.ENABLE_ITEM_SUCCESS,
      });
    })
    .catch(() => {
      dispatch({
        type: ACTION_TYPE.ENABLE_ITEM_FAILURE,
        payload: { elementType, elementId },
      });
    });
};

export const disableItemFromSerendipity = (elementType, elementId) => (dispatch) => {
  dispatch({
    type: ACTION_TYPE.DISABLE_ITEM_INIT,
    payload: { elementType, elementId },
  });

  const params = { element_type: elementType, element_id: elementId };
  return apiFetch('POST', { endPoint: 'serendipity/items/disable' }, params)
    .then(() => {
      dispatch({
        type: ACTION_TYPE.DISABLE_ITEM_SUCCESS,
      });
    })
    .catch(() => {
      dispatch({
        type: ACTION_TYPE.DISABLE_ITEM_FAILURE,
        payload: { elementType, elementId },
      });
    });
};

export const getSerendipityPreferences = () => (dispatch) => {
  return apiFetch('GET', { endPoint: 'serendipity/items' })
    .then((payload) => {
      dispatch({
        type: ACTION_TYPE.GET_PREFERENCES_SUCCESS,
        payload,
      });
    });
};

export const pushElementInHistory = element => (dispatch) => {
  dispatch({
    type: ACTION_TYPE.PUSH_ELEMENT_IN_HISTORY,
    payload: element,
  });
};


export const getSerendipityAction = () => (dispatch, getState) => {
  const { serendipity: { actionInContext, history: serendipityHistory } } = getState();

  if (actionInContext) {
    return actionInContext;
  }

  const items = dispatch(getOnGoingActivity());
  const item = _.find(items, (element) => {
    if (!element.serendipityInfo.enabled) {
      return false;
    }

    return !_.find(serendipityHistory, { type: element.serendipityInfo.type, id: element.id });
  });

  if (item) {
    dispatch(pushElementInHistory(item));
    switch (item.serendipityInfo.type) {
      case NARRATIVE:
        return (() => {
          history.push(`/narratives/${item.id}`);
        });
      case FEEDBACK_USERS:
        return (() => {
          history.push('/recommendations/users');
        });
      case FEEDBACK_TABLES:
        return (() => {
          history.push('/recommendations/tables');
        });
      case ELEMENT:
        return (() => {
          history.push(`/elements/${item.id}`);
        });
      case THEME_TABLE:
        return (() => {
          history.push(`/theme-table/${item.id}`);
        });
      case THINK_SEED:
        return (() => {
          history.push(`/theme-table/${item.id}`);
        });
      case THINK_TANK:
        return (() => {
          history.push(`/theme-table/${item.id}`);
        });
      case SPEED_DATING_MEETING:
        return (() => {
          history.push(`/zoom-meeting/${item.zoom_data.id}`);
        });
      default:
        return null;
    }
  }
  return null;
};

export const setSerendipityActionInContext = (action, priority = PRIORITIES.MEDIUM) => (dispatch) => {
  dispatch({
    type: ACTION_TYPE.SET_ACTION_IN_CONTEXT,
    payload: { action, priority },
  });
};



// WEBPACK FOOTER //
// ./src/modules/serendipity/actions.js